module.exports = __webpack_public_path__ + "img/selected1-min.db988406.png";